// ---------------------------------------------------------------
// sharedSnapshot.js — Una sola conexión con Firebase por consulta,
// compartida por todos los componentes que la necesiten.
//
// Antes, cada componente abría su propia escucha: la lista de
// usuarios, las tareas o la configuración se pedían 4 o 5 veces a
// la vez. Ahora la primera abre la conexión y las demás se
// enganchan a ella (y reciben al instante el último dato conocido,
// sin esperar a la red). Cuando el último se va, se cierra.
// ---------------------------------------------------------------
const cache = new Map();

/**
 * @param key      identificador de la consulta ("users", "tasks:2026-07"…)
 * @param factory  (onData, onError) => unsubscribe  — crea la escucha real
 * @param onData   se llama con cada actualización
 * @param onError  opcional
 * @returns función para desengancharse
 */
export function sharedSubscribe(key, factory, onData, onError) {
  let entry = cache.get(key);

  if (!entry) {
    entry = { subs: new Set(), errs: new Set(), data: undefined, unsub: null };
    cache.set(key, entry);
    entry.unsub = factory(
      (data) => {
        entry.data = data;
        entry.subs.forEach((fn) => fn(data));
      },
      (err) => {
        entry.errs.forEach((fn) => fn(err));
      }
    );
  }

  entry.subs.add(onData);
  if (onError) entry.errs.add(onError);
  // Si ya hay datos, el nuevo componente los pinta sin esperar
  if (entry.data !== undefined) onData(entry.data);

  return () => {
    entry.subs.delete(onData);
    if (onError) entry.errs.delete(onError);
    if (entry.subs.size === 0) {
      entry.unsub?.();
      cache.delete(key);
    }
  };
}
